module.exports = __webpack_public_path__ + "static/media/text-block-video-2.d786f5df.png";